import {
  TicketValidationParams,
  TicketValidationResponse,
} from './types/tickets-api.type';

import { easyEstimatorApi } from '~/api/easy-estimator-api/easyEstimatorService';
import { ApiUrl } from '~/core/enums';

const ticketValidationService = easyEstimatorApi.injectEndpoints({
  endpoints: (builder) => ({
    /** Query the api to check if a ticket is valid */
    validateTicket: builder.query<
      TicketValidationResponse,
      TicketValidationParams
    >({
      query: ({ ...params }) => ({
        url: ApiUrl.TICKETS,
        method: 'GET',
        params,
      }),
    }),
  }),
});

export const { useLazyValidateTicketQuery } = ticketValidationService;
